import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import Paper from "@mui/material/Paper";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import EventNoteIcon from "@mui/icons-material/EventNote";
import SupportIcon from "@mui/icons-material/Support";

import {getUserInfo} from "api/Api";

const borderStyle = {
    width: "90px",
    height: "90px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
}

const ProfHeader = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [info, setInfo] = useState("");
    const [pathName, setPathName] = useState('');
    const [number, setNumber] = useState([0,0,0]);
    const [active1, setActive1] = React.useState(true);
    const [active2, setActive2] = React.useState(false);

    // console.log(info);

    React.useEffect(()=>{
        const pathName = window.location.pathname;
        setPathName(pathName);
        if(pathName==='/edit-prof'){
            setActive1(true);
            setActive2(false);
        }
        else{
            setActive1(false);
            setActive2(true);
        }

        setLoading(true);
        getUserInfo((isOk, data)=>{
            if(!isOk){
                setLoading(false);
                setError(data);
                // console.log(data)
            }
            else{
                setLoading(false);
                setInfo(data.user_info);
                setNumber(()=> [data.service_count, data.ticket_count, data.factor_count]);
                // console.log(data);
            }
        })

    },[window.location.pathname])

    const onClick1=()=>{
        setActive1(true);
        setActive2(false)
    }
    const onClick2=()=>{
        setActive1(false);
        setActive2(true)
    }
    return (
        <>
            <Paper elevation={1}>
            <div className="mb-5 mb-xl-10">
                <div className="card-body pt-9 pb-0">
                    <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
                        <div className="me-7 mb-4">
                            <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                                <img src="./../../assets/media/avatars/user1.png" alt="image"/>
                                <div
                                    className="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px"/>
                            </div>
                        </div>
                        <div className="">
                            <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                <div className="d-flex flex-column">
                                    <div className="d-flex align-items-center mb-2">
                                    <span className="text-gray-900 text-hover-primary fs-4 fw-bolder me-1">
                                        {
                                            info.first_name+" "+info.last_name
                                        }
                                    </span>
                                        <span className="badge badge-light-success fw-bolder ms-2 fs-8 py-1 px-3"
                                        >آخرین بروزرسانی</span>
                                    </div>
                                    <div className={"d-flex justify-content-start align-items-center mt-lg-6 mt-2 "}>
                                        <div style={{width: "175px"}} className={"mt-md-0 mt-2"}>
                                            <span className={"pe-2"}>کدملی:</span>
                                            {
                                                info.nid ? <span>{info.nid}</span>
                                                    :
                                                    <span className={"badge badge-light-danger"}>ثبت نشده</span>
                                            }
                                        </div>
                                        <div style={{width: "175px"}} className={"ps-lg-5 ps-0 mt-md-0 mt-2"}>
                                            <span className={"pe-2"}>شناسه ملی:</span>
                                            {
                                                info.nid_num ? <span>{info.nid_num}</span>
                                                    :
                                                    <span className={"badge badge-light-danger"}>ثبت نشده</span>
                                            }
                                        </div>
                                    </div>
                                    <div className={"d-flex justify-content-start align-items-center mt-2 "}>

                                        <div className={"mt-md-0 mt-2"} style={{width: "175px"}}>
                                            <span className={"pe-2"}>شرکت:</span>
                                            {
                                                info.company ? <span>{info.company}</span>
                                                    :
                                                    <span className={"badge badge-light-danger"}>ثبت نشده</span>
                                            }
                                        </div>
                                        <div className={"ps-lg-5 ps-0 mt-md-0 mt-2"} style={{width: "175px"}}>
                                            <span className={"pe-2"}>موبایل:</span>
                                            {
                                                info.mobile ? <span>{info.mobile}</span>
                                                    :
                                                    <span className={"badge badge-light-danger"}>ثبت نشده</span>
                                            }
                                        </div>
                                    </div>
                                    <div className={"d-flex justify-content-start align-items-center mt-md-2 mt-0 "}>
                                        <div className={"mt-md-0 mt-2"} style={{width: "175px"}}>
                                            <span className={"pe-2"}>شماره اقتصادی:</span>
                                            {
                                                info.economic_num ? <span>{info.economic_num}</span>
                                                    :
                                                    <span className={"badge badge-light-danger"}>ثبت نشده</span>
                                            }
                                        </div>
                                        <div className={"ps-lg-5 ps-0 mt-md-0 mt-2"} style={{width: "175px"}}>
                                            <span className={"pe-2"}>شماره ثبت:</span>
                                            {
                                                info.register_num ? <span>{info.register_num}</span>
                                                    :
                                                    <span className={"badge badge-light-danger"}>ثبت نشده</span>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="my-4">
                                    <div className="">
                                        <div className="row">
                                            <div className={"col-4"}>
                                                <Link to={"/services"}
                                                    className="border bg-primary border-primary border-dashed rounded p-3"
                                                    style={borderStyle}>
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <div className="fs-1 fw-bolder counted text-white" data-kt-countup="true"
                                                             data-kt-countup-value="4500" data-kt-countup-prefix="$">{number[0]}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex fw-bold fs-6 text-white text-center">
                                                        <MiscellaneousServicesIcon className={"f-13"}/>
                                                        <span className={"ms-1"}>
                                                          سرویس
                                                        </span>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className={"col-4"}>
                                                <Link to={"/tickets"}
                                                    className="border bg-success border-success border-dashed rounded p-3"
                                                    style={borderStyle}>
                                                    <div className="d-flex align-items-center justify-content-center text-white">
                                                        <div className="fs-1 fw-bolder counted" data-kt-countup="true"
                                                             data-kt-countup-value="75">{number[1]}
                                                        </div>
                                                    </div>
                                                    <div className="fw-bold fs-6 text-white text-center">
                                                        <EventNoteIcon className={"f-13"}/>
                                                        <span className={"ms-1"}>
                                                          تیکت
                                                        </span>
                                                    </div>
                                                </Link>
                                            </div>
                                            <div className={"col-4"}>
                                                <Link to={"/factors"}
                                                    className="border bg-danger border-danger border-dashed rounded p-3"
                                                    style={borderStyle}>
                                                    <div className="d-flex justify-content-center align-items-center text-white">
                                                        <div className="fs-1 fw-bolder counted" data-kt-countup="true"
                                                             data-kt-countup-value="60" data-kt-countup-prefix="%">{number[2]}
                                                        </div>
                                                    </div>
                                                    <div className="fw-bold fs-6 text-center text-white">
                                                        <SupportIcon className={"f-13"}/>
                                                        <span className={"ms-1"}>
                                                          فاکتور
                                                        </span>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"edit-prof d-flex justify-content-start align-items-center py-4"}>
                    <Link to={"/edit-prof"} className={active1 ? "px-5 active" : "px-5"} onClick={onClick1}>ویرایش اطلاعات کاربری</Link>
                    <Link to={"/change-pass"} className={active2 ? "px-5 active" : "px-5"} onClick={onClick2}>تغییر کلمه عبور</Link>
                </div>
            </div>
        </Paper>
        </>

    );
};

export default ProfHeader;